import { Card, Flex } from "antd";

import { AuditMap } from "audit/components";
import { APIProvider } from "@vis.gl/react-google-maps";
import variables from "../../../../../_variables.scss";
import { IAuditAppointment } from "audit/models";

type Props = {
  loading?: boolean;
  auditAppointments?: IAuditAppointment[];
};

export const FieldAuditorMapCard = ({ loading, auditAppointments }: Props) => {
  return (
    <Card loading={loading} bordered={false} data-testid='fieldAuditorMapCard'>
      <Flex vertical gap={variables.gap}>
        <h1>Audit Map</h1>
        <APIProvider
          apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ""}
          libraries={["marker"]}
        >
          <AuditMap auditAppointments={auditAppointments ?? []} />
        </APIProvider>
      </Flex>
    </Card>
  );
};
